import { ApolloClient, ErrorLike, gql, OperationVariables } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { IAgGridTblPayload } from 'fso-fincrime-sdk-ui';

import { IGraph } from '../../ts/entities/chart/IChart';
import { IChartGraphData, ICardGraphData } from '../../ts/entities/chart/IGraphData';

export const QUERY_DASHBOARD_WORKLOAD_CARD_DATA = gql`
  query Query($workflowName: String, $workflowVersion: Int) {
    cardViewDetails(workflowName: $workflowName, workflowVersion: $workflowVersion) {
      inProgress
      investigated
      caseClosed
      caseOutstanding
      overallCompletedPercentage
    }
  }
`;

export const QUERY_CHARTS_DATA = gql`
  query ChartsQuery($charts: Charts) {
    chartsQuery(charts: $charts) {
      datasets {
        data
        label
        backgroundColor
      }
      labels
      stacked
      workflowName
      workflowVersion
      title
      type
      indexAxis
    }
  }
`;

export const GQL_CHARTS_DATA = (
  graphs: IGraph[],
  taskListFilter: IAgGridTblPayload | undefined,
  toSkip: boolean
): {
  data: IChartGraphData | undefined;
  error: ErrorLike | undefined;
  loading: boolean;
  refetch: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloClient.QueryResult<IChartGraphData>>;
} => {
  const newFilter: any = { ...taskListFilter }; // TODO
  if (toSkip && taskListFilter?.filterModel) {
    toSkip = false;

    const keys = Object.keys(taskListFilter.filterModel);
    const filters = [];
    for (const key of keys) {
      filters.push({
        key,
        value: taskListFilter.filterModel[key],
      });
    }

    newFilter.filterModel = filters;
  }
  const { error, data, loading, refetch } = useQuery<IChartGraphData>(QUERY_CHARTS_DATA, {
    variables: {
      charts: {
        graphs,
        workItems: newFilter,
      },
    },
    fetchPolicy: 'no-cache',
    initialFetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    refetchWritePolicy: 'overwrite',
    skip: toSkip,
  });
  return {
    data,
    error,
    loading,
    refetch,
  };
};

export const GQL_DASHBOARD_WORKLOAD_CARD_DATA = (
  workflowName: string,
  workflowVersion: number,
  toSkip: boolean
): {
  data: ICardGraphData | undefined;
  error: ErrorLike | undefined;
  loading: boolean;
  refetch: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloClient.QueryResult<ICardGraphData>>;
} => {
  const { error, data, loading, refetch } = useQuery<ICardGraphData>(
    QUERY_DASHBOARD_WORKLOAD_CARD_DATA,
    {
      skip: toSkip,
      variables: {
        workflowName,
        workflowVersion,
      },
    }
  );
  return {
    data,
    error,
    loading,
    refetch,
  };
};
